import { Color3 } from "@babylonjs/core/Maths/math.color";
import { CreateLines } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { CreateCylinder } from "@babylonjs/core/Meshes/Builders/cylinderBuilder";
import { Polygon } from "@babylonjs/core/Meshes/polygonMesh";
import { Vector3, Vector4 } from "@babylonjs/core/Maths/math.vector";
import { ElementGeometry } from "./ElementGeometry";
import { RoomManager } from './../../RoomManager';
import { Util } from "../../utils/Util";
export class PillarC extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mElementParams = {};
        this.mElementParams.privacyFilter = false;
        this.mElementParams.blindVisible = false;
        this.mElementParams.blindDepth = 0.07;
        this.mElementParams.blindOpeningAngle = 60;
        this.mElementParams.blindOpeningWidth = 0;
        this.mElementParams.ColumnCount = 2;
        this.mPoints = new Array();
    }
    getType() {
        return ("PillarC");
    }
    setMesh(pMesh) {
        //
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0.5;
        tParams.depth = 0.5;
        tParams.height = 2.6;
        tParams.floorOffset = 0.0;
        tParams.color = "#ffffff";
        if (this.mPoints != null) {
            this.mPoints.push(new Vector3(0, 0, 0));
            this.mPoints.push(new Vector3(tParams.width * 0.5, 0, 0));
        }
        return (tParams);
    }
    create2dGeometry(pParent) {
        this.createPillar(pParent, true);
    }
    create3dGeometry(pParent) {
        this.createPillar(pParent);
    }
    serializeIOData() {
        return (this.mElementParams);
    }
    loadIOData(pData) {
        //
    }
    setPoints(pPoints) {
        this.mPoints = [];
        for (let tPoint of pPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tPoint.x;
            tP.z = tPoint.z;
            this.mPoints.push(tP);
        }
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.mRoomElement.setClosedPolygon(true);
    }
    getEOXDescription(pDocument, pParentNode) {
        let tAttribsList = new Array();
        let child = pDocument.createElement("dummy"); //dummy node definition for further use
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "structure_type", value: "Pillar_Circle" });
        let tRoomElementNode = Util._xmlAddChildNode(pDocument, pParentNode, "object", "", tAttribsList);
        // define category
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "category", "Other", null);
        // position
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "x", value: this.mRoomElement.node.position.x.toString() });
        tAttribsList.push({ qualifiedName: "y", value: (this.mRoomElement.node.position.y).toString() });
        tAttribsList.push({ qualifiedName: "z", value: (-this.mRoomElement.node.position.z).toString() });
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "position", "", tAttribsList);
        // rotation
        let t3dRotation = this.mRoomElement.node.rotationQuaternion;
        tAttribsList = [];
        if (t3dRotation != null) {
            tAttribsList.push({ qualifiedName: "x", value: (-t3dRotation.x).toString() });
            tAttribsList.push({ qualifiedName: "y", value: (-t3dRotation.z).toString() });
            tAttribsList.push({ qualifiedName: "z", value: (-t3dRotation.y).toString() });
            tAttribsList.push({ qualifiedName: "w", value: (-t3dRotation.w).toString() });
            Util._xmlAddChildNode(pDocument, tRoomElementNode, "rotation", "", tAttribsList);
        }
        else {
            tAttribsList.push({ qualifiedName: "x", value: "0" });
            tAttribsList.push({ qualifiedName: "y", value: "0" });
            tAttribsList.push({ qualifiedName: "z", value: "0" });
            tAttribsList.push({ qualifiedName: "w", value: "1" });
            Util._xmlAddChildNode(pDocument, tRoomElementNode, "rotation", "", tAttribsList);
        }
        // diameter
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "diameter", this.mRoomElement.width.toString(), null);
        // height
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "height", this.mRoomElement.height.toString(), null);
        // color
        tAttribsList = [];
        if (this.mRoomElement.color.trim() != '') {
            let tcolor = Util.hexToRGB(this.mRoomElement.color);
            tAttribsList.push({ qualifiedName: "r", value: tcolor.r.toString() });
            tAttribsList.push({ qualifiedName: "g", value: tcolor.g.toString() });
            tAttribsList.push({ qualifiedName: "b", value: tcolor.b.toString() });
            Util._xmlAddChildNode(pDocument, tRoomElementNode, "color", "", tAttribsList);
        }
    }
    createPillar(pParent, pOutline = false) {
        let tW = this.mRoomElement.width;
        let tH = this.mRoomElement.height;
        let tTessellation = 40;
        let faceUV = [
            new Vector4(0, 0, tW, -tW),
            new Vector4(0, 0, -tW * Math.PI, tH),
            new Vector4(0, 0, tW, tW)
        ];
        if (pOutline) {
            let tC = Polygon.Circle(this.mRoomElement.width * 0.5, undefined, undefined, tTessellation);
            let tPoints = new Array();
            for (let tP of tC) {
                let tCP = new Vector3(tP.x, this.mRoomElement.height + 0.01, tP.y);
                tPoints.push(tCP);
            }
            if (tPoints.length > 2)
                tPoints.push(tPoints[0]);
            let tLines = CreateLines("", {
                points: tPoints,
                updatable: false,
                instance: null
            }, this.mScene);
            tLines.isPickable = false;
            tLines.intersectionThreshold = 0;
            tLines.color = Color3.Black();
            tLines.position.y = RoomManager.WALLOPENING_2D_LINE_HEIGHT;
            tLines.parent = pParent;
            this.prepare2dMesh(tLines);
        }
        let tCylinder = CreateCylinder("", {
            height: this.mRoomElement.height,
            diameter: this.mRoomElement.width,
            faceUV: faceUV,
            tessellation: tTessellation
        }, this.mScene);
        tCylinder.parent = pParent;
        tCylinder.material = this.mRoomElement.localMaterial;
        tCylinder.position.y = this.mRoomElement.height * 0.5 + this.mRoomElement.floorOffset;
        this.prepare3dMesh(tCylinder);
    }
}
PillarC.PROP_KEY_COLOR = "room:RoomElement:PillarC:color";
